<!-- Поверхность статическая: скрипт покрытия читает её как атрибут, и с
     динамическим выражением весь файл выпадает из проверки.
     Различает инструменты ЯКОРЬ — он несёт код инструмента (anchorFor).
     Поля настроек регистрирует страница агента: она владеет agent().tools и
     знает о них при закрытом дравере, а контролы здесь только отдают свои
     элементы, чтобы подсветка и карточка предложения появились на месте. -->
<div
     snAssistantSurface="systemTool"
     i18n-surfaceTitle="@@systemTool.surface"
     surfaceTitle="System tool" class="system-tool-container" [class.embedded]="isEmbedded">
  <div class="system-tool-page-container">
    <div class="embedded-content">

      <!-- Header section -->
      <div class="header-section">
        <h2 i18n="@@systemTool.header.title">Edit system tool</h2>
        <p class="header-description" i18n="@@systemTool.header.subtitle">Configure system tool settings and description.</p>
      </div>

      <!-- Form content -->
      <div class="webhook-form-container">
        <!-- Configuration Card -->
        <p-card
          i18n-header="@@systemTool.config.header" header="Configuration"
          i18n-subheader="@@systemTool.config.subheader" subheader="Describe to the LLM how and when to use the tool."
          styleClass="outer-card">
          <!-- Nested Configuration Fields Card -->
          <p-card styleClass="nested-card">
            <div class="form-field">
              <label for="tool-name" class="field-label" i18n="@@systemTool.field.name">Name</label>
              <input
                id="tool-name"
                type="text"
                pInputText
                [value]="localizedTitle"
                readonly
                class="readonly-input">
            </div>

            <div class="form-field">
              <label for="tool-description" class="field-label">
                <ng-container i18n="@@systemTool.field.descriptionOptional">Description (optional)</ng-container>
                <span class="show-default-link" (click)="showDefaultDescription()" i18n="@@systemTool.showDefault">Show Default</span>
              </label>
              <textarea
                snAssistantSkip
                        [snAssistantAnchor]="anchorFor('toolDescription')"
                id="tool-description"
                pTextarea
                [ngModel]="agentTool?.custom_description || ''"
                (ngModelChange)="updateDescription($event)"
                i18n-placeholder="@@systemTool.field.descriptionPlaceholder"
                placeholder="Leave blank to use the default optimized LLM prompt."
                rows="4"
                [autoResize]="true"
                class="tool-description-textarea">
              </textarea>
            </div>

            <div class="form-field">
              <div class="switch-field">
                <label for="disable-interruptions" class="switch-label" i18n="@@systemTool.field.disableInterruptions">Disable interruptions</label>
                <p-toggleswitch
                  snAssistantSkip
                        [snAssistantAnchor]="anchorFor('disableInterruptions')"
                  id="disable-interruptions"
                  [ngModel]="agentTool?.custom_disable_interruptions || false"
                  (ngModelChange)="updateDisableInterruptions($event)">
                </p-toggleswitch>
              </div>
              <p class="field-description" i18n="@@systemTool.field.disableInterruptionsHint">Select this box to disable interruptions while the tool is running.</p>
            </div>
          </p-card>
        </p-card>

        <!-- Transfer to operator (SIP transfer to a phone number) -->
        @if (isOperatorTool()) {
          <p-card
            i18n-header="@@systemTool.operator.rulesHeader" header="Transfer Rules"
            i18n-subheader="@@systemTool.operator.rulesSubheader" subheader="Define the conditions for transferring the call to a human operator via SIP."
            styleClass="outer-card">
          <div class="default-number-field">
            <label class="field-label" for="defaultPhoneNumber" i18n="@@systemTool.operator.defaultNumber.label">
              Number to call the operator from
            </label>
            <p-select
              snAssistantSkip
                        [snAssistantAnchor]="anchorFor('defaultPhoneNumber')"
              inputId="defaultPhoneNumber"
              name="default_phone_number_agent_id"
              [options]="phoneNumberGroups"
              [group]="true"
              optionLabel="label"
              optionValue="value"
              optionGroupLabel="label"
              optionGroupChildren="items"
              [showClear]="true"
              [loading]="phoneNumbersLoading"
              i18n-placeholder="@@systemTool.operator.defaultNumber.placeholder"
              placeholder="Not selected"
              [ngModel]="defaultPhoneNumberAgentId"
              (ngModelChange)="updateDefaultPhoneNumber($event)"
              styleClass="w-full">
            </p-select>

            <ul class="field-description default-number-rules">
              <li i18n="@@systemTool.operator.defaultNumber.rulePhone">
                If the conversation is a phone call, the operator is dialled from that same number.
              </li>
              <li i18n="@@systemTool.operator.defaultNumber.ruleWeb">
                If the conversation is not over the phone, the number selected here is used.
              </li>
              <li i18n="@@systemTool.operator.defaultNumber.ruleNone">
                If no number is selected and the conversation is not over the phone, the transfer will not work.
              </li>
            </ul>

            <p class="field-description">
              <span i18n="@@systemTool.operator.numbersHint.prefix">Numbers are configured in the </span><a routerLink="/phone-numbers" i18n="@@systemTool.operator.phoneOnly.linkText">Phone Numbers</a><span i18n="@@systemTool.operator.numbersHint.suffix"> section.</span>
            </p>
          </div>
            <div class="transfer-rules-header">
              <p-button
                i18n-label="@@systemTool.addRule" label="Add Rule"
                icon="pi pi-plus"
                severity="secondary"
                [outlined]="true"
                size="small"
                class="add-rule-button"
                (click)="addTransferRule()">
              </p-button>
            </div>

            @if (transferRules.length > 0) {
              <div class="transfer-rules-list">
                @for (rule of transferRules; track rule.id; let i = $index) {
                  <p-card class="transfer-rule-item nested-card" [class.invalid]="!isTransferRuleValid(rule)">
                    <div class="rule-header">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.operator.field.mode">Transfer mode</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        size="small"
                        class="delete-rule-icon-button"
                        (click)="removeTransferRule(i)">
                      </p-button>
                    </div>
                    <div class="rule-field" [class.invalid]="!rule.transfer_mode">
                      <p-select
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        [options]="transferModeOptions"
                        name="transfer_mode"
                        [(ngModel)]="rule.transfer_mode"
                        optionLabel="label"
                        optionValue="value"
                        i18n-placeholder="@@systemTool.operator.field.modePlaceholder"
                        placeholder="Select transfer mode"
                        class="agent-dropdown">
                      </p-select>
                      @if (!rule.transfer_mode) {
                        <div class="validation-error" i18n="@@systemTool.operator.field.modeRequired">Transfer mode is required</div>
                      }
                    </div>

                    <div class="rule-field" [class.invalid]="!rule.transfer_to_phone_number?.trim()">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.operator.field.phone">Phone number</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <input
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pInputText
                        type="tel"
                        name="transfer_to_phone_number"
                        [(ngModel)]="rule.transfer_to_phone_number"
                        placeholder="+15551234567"
                        class="delay-input">
                      @if (!rule.transfer_to_phone_number?.trim()) {
                        <div class="validation-error" i18n="@@systemTool.operator.field.phoneRequired">Phone number is required</div>
                      }
                    </div>

                    <div class="rule-field" [class.invalid]="!rule.condition?.trim()">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.operator.field.condition">Condition</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <textarea
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pTextarea
                        name="condition"
                        [(ngModel)]="rule.condition"
                        i18n-placeholder="@@systemTool.operator.field.conditionPlaceholder"
                        placeholder="When the caller explicitly asks to speak with a human, or the request is outside the agent's scope"
                        rows="2"
                        class="condition-textarea">
                      </textarea>
                      <p class="field-description" i18n="@@systemTool.operator.field.conditionHint">Describe to the LLM exactly when to initiate transfer to this operator. The same condition is used to pick between multiple rules.</p>
                      @if (!rule.condition?.trim()) {
                        <div class="validation-error" i18n="@@systemTool.operator.field.conditionRequired">Condition is required</div>
                      }
                    </div>

                    <div class="rule-field">
                      <label class="field-label" i18n="@@systemTool.operator.field.message">Transfer message (to caller)</label>
                      <textarea
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pTextarea
                        name="transfer_message"
                        [(ngModel)]="rule.transfer_message"
                        i18n-placeholder="@@systemTool.operator.field.messagePlaceholder"
                        placeholder="I will now connect you with an operator"
                        rows="2"
                        class="message-textarea">
                      </textarea>
                      <p class="field-description" i18n="@@systemTool.operator.field.messageHint">Optional — spoken to the CALLER right before the transfer starts.</p>
                    </div>

                    @if (rule.transfer_mode === 'WarmMessage') {
                      <div class="rule-field">
                        <label class="field-label" i18n="@@systemTool.operator.field.briefing">Operator briefing (to operator)</label>
                        <textarea
                          snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                          pTextarea
                          name="operator_briefing"
                          [(ngModel)]="rule.operator_briefing"
                          i18n-placeholder="@@systemTool.operator.field.briefingPlaceholder"
                          placeholder="Message to speak to the operator on connect"
                          rows="3"
                          class="message-textarea">
                        </textarea>
                        <p class="field-description" i18n="@@systemTool.operator.field.briefingHint">Optional — spoken to the OPERATOR on connect. Used only in «Warm — custom message» mode.</p>
                      </div>
                    }

                    <div class="rule-field">
                      <label class="field-label" i18n="@@systemTool.operator.field.ringingTimeout">Ringing timeout (seconds)</label>
                      <input
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pInputText
                        type="number"
                        name="ringing_timeout_seconds"
                        [(ngModel)]="rule.ringing_timeout_seconds"
                        placeholder="60"
                        min="1"
                        max="300"
                        class="delay-input">
                      <p class="field-description" i18n="@@systemTool.operator.field.ringingTimeoutHint">Optional — how long to wait for the operator to pick up before giving up. Defaults to a sensible value if empty.</p>
                    </div>
                  </p-card>
                }
              </div>
            }
          </p-card>
        }

        <!-- Transfer Rules Card (only for transfer-to-agent tool) -->
        @if (tool && tool.code === 'transfer-to-agent') {
          <p-card
            i18n-header="@@systemTool.agent.rulesHeader" header="Transfer Rules"
            i18n-subheader="@@systemTool.agent.rulesSubheader" subheader="Define the conditions for transferring to different agents."
            styleClass="outer-card">
            <div class="transfer-rules-header">
              <p-button
                i18n-label="@@systemTool.addRule" label="Add Rule"
                icon="pi pi-plus"
                severity="secondary"
                [outlined]="true"
                size="small"
                class="add-rule-button"
                (click)="addTransferRule()">
              </p-button>
            </div>

            @if (transferRules.length > 0) {
              <div class="transfer-rules-list">
                @for (rule of transferRules; track rule.id; let i = $index) {
                  <p-card class="transfer-rule-item nested-card" [class.invalid]="!isTransferRuleValid(rule)">
                    <div class="rule-header">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.agent.field.target">Agent</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        size="small"
                        class="delete-rule-icon-button"
                        (click)="removeTransferRule(i)">
                      </p-button>
                    </div>
                    <div class="rule-field" [class.invalid]="!rule.transfer_to_agent_id">
                      <p-select
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        [options]="availableAgents"
                        name="transfer_to_agent_id"
                        [(ngModel)]="rule.transfer_to_agent_id"
                        optionLabel="title"
                        optionValue="id"
                        i18n-placeholder="@@systemTool.agent.field.targetPlaceholder"
                        placeholder="Select agent"
                        class="agent-dropdown">
                      </p-select>
                      @if (!rule.transfer_to_agent_id) {
                        <div class="validation-error" i18n="@@systemTool.agent.field.targetRequired">Agent is required</div>
                      }
                    </div>

                    <div class="rule-field" [class.invalid]="!rule.condition?.trim()">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.agent.field.condition">Condition</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <textarea
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pTextarea
                        name="condition"
                        [(ngModel)]="rule.condition"
                        i18n-placeholder="@@systemTool.agent.field.conditionPlaceholder"
                        placeholder="If user explicitly says that he wants to hear funny jokes"
                        rows="2"
                        class="condition-textarea">
                      </textarea>
                      @if (!rule.condition?.trim()) {
                        <div class="validation-error" i18n="@@systemTool.agent.field.conditionRequired">Condition is required</div>
                      }
                    </div>

                    <div class="rule-field">
                      <label class="field-label" i18n="@@systemTool.agent.field.delay">Delay before transfer (milliseconds)</label>
                      <input
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pInputText
                        type="number"
                        name="delay_before_transfer_ms"
                        [(ngModel)]="rule.delay_before_transfer_ms"
                        placeholder="0"
                        class="delay-input">
                    </div>

                    <div class="rule-field">
                      <label class="field-label" i18n="@@systemTool.agent.field.message">Transfer Message</label>
                      <textarea
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pTextarea
                        name="transfer_message"
                        [(ngModel)]="rule.transfer_message"
                        i18n-placeholder="@@systemTool.agent.field.messagePlaceholder"
                        placeholder="I will transfer you to a specialist"
                        rows="2"
                        class="message-textarea">
                      </textarea>
                    </div>

                    <div class="rule-field">
                      <div class="switch-field">
                        <label class="switch-label" i18n="@@systemTool.agent.field.firstMessage">Enable First Message</label>
                        <p-toggleswitch
 snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')" name="enable_first_message"
 [(ngModel)]="rule.enable_first_message"></p-toggleswitch>
                      </div>
                      <p class="field-description" i18n="@@systemTool.agent.field.firstMessageHint">When ON — the target agent plays its first message after transfer. When OFF (or if the target has no first message) — the target continues the conversation from the last user message, using the full prior chat history and without greeting or reintroducing itself.</p>
                    </div>

                  </p-card>
                }
              </div>
            }
          </p-card>
        }

        <!-- Knowledge rules (only for get-knowledge tool) — SKN-349 -->
        @if (isKnowledgeTool()) {
          <p-card
            i18n-header="@@systemTool.knowledge.rulesHeader" header="Rules"
            i18n-subheader="@@systemTool.knowledge.rulesSubheader" subheader="Each rule is one topic the agent can answer, and the text it answers with."
            styleClass="outer-card">
            <div class="transfer-rules-header">
              <p-button
                i18n-label="@@systemTool.addRule" label="Add Rule"
                icon="pi pi-plus"
                severity="secondary"
                [outlined]="true"
                size="small"
                class="add-rule-button"
                (click)="addTransferRule()">
              </p-button>
            </div>

            @if (transferRules.length > 0) {
              <div class="transfer-rules-list">
                @for (rule of transferRules; track rule.id; let i = $index) {
                  <p-card class="transfer-rule-item nested-card" [class.invalid]="!isKnowledgeRuleValid(rule)">
                    <div class="rule-header">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.knowledge.field.topic">Topic</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        size="small"
                        class="delete-rule-icon-button"
                        (click)="removeTransferRule(i)">
                      </p-button>
                    </div>

                    <div class="rule-field" [class.invalid]="!rule.condition?.trim()">
                      <textarea
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pTextarea
                        name="condition"
                        [(ngModel)]="rule.condition"
                        i18n-placeholder="@@systemTool.knowledge.field.topicPlaceholder"
                        placeholder="Delivery times and shipping cost"
                        rows="2"
                        class="condition-textarea">
                      </textarea>
                      <p class="field-description" i18n="@@systemTool.knowledge.field.topicHint">What this entry covers. The agent picks between rules by these descriptions, so keep them short and clearly different from each other.</p>
                      @if (!rule.condition?.trim()) {
                        <div class="validation-error" i18n="@@systemTool.knowledge.field.topicRequired">Topic is required</div>
                      }
                    </div>

                    <div class="rule-field" [class.invalid]="!rule.answer?.trim()">
                      <label class="field-label">
                        <ng-container i18n="@@systemTool.knowledge.field.answer">Answer</ng-container>
                        <span style="color: var(--sn-status-fail);">*</span>
                      </label>
                      <textarea
                        snAssistantSkip
                        [snAssistantAnchor]="anchorFor('transferRules')"
                        pTextarea
                        name="answer"
                        [(ngModel)]="rule.answer"
                        i18n-placeholder="@@systemTool.knowledge.field.answerPlaceholder"
                        placeholder="Orders placed before 6pm ship the same day. Delivery within the city takes 1-2 days and is free over $50."
                        rows="6"
                        class="answer-textarea">
                      </textarea>
                      <p class="field-description" i18n="@@systemTool.knowledge.field.answerHint">The facts the agent answers with. It retells them in its own words and in the language of the call, so write plain text rather than a script — but numbers, names and prices are kept exactly as written.</p>
                      @if (!rule.answer?.trim()) {
                        <div class="validation-error" i18n="@@systemTool.knowledge.field.answerRequired">Answer is required</div>
                      }
                    </div>

                  </p-card>
                }
              </div>
            }
          </p-card>
        }
      </div>

      <!-- Desktop Action Buttons -->
      <div class="action-buttons">
        <p-button
          type="button"
          i18n-label="@@common.back" label="Back"
          severity="secondary"
          [outlined]="true"
          icon="pi pi-arrow-left"
          (click)="cancel()">
        </p-button>
        <p-button
          type="button"
          i18n-label="@@common.save" label="Save"
          icon="pi pi-check"
          (click)="save()">
        </p-button>
      </div>

      <!-- Mobile Bottom Toolbar with PrimeNG -->
      <p-toolbar class="mobile-bottom-toolbar">
        <ng-template pTemplate="start">
          <p-button
            type="button"
            i18n-label="@@common.back" label="Back"
            severity="secondary"
            [outlined]="true"
            (click)="cancel()"
            icon="pi pi-arrow-left"
            size="small">
          </p-button>
        </ng-template>

        <ng-template pTemplate="end">
          <p-button
            type="button"
            i18n-label="@@common.save" label="Save"
            (click)="save()"
            icon="pi pi-check"
            size="small">
          </p-button>
        </ng-template>
      </p-toolbar>

    </div>
  </div>
</div>
